import { defineMessages } from 'react-intl';
import {
  COOKIE_PREFERENCES_COOKIE,
  IDAGIO_AUTHORISED_COOKIE,
  TRACKING_TOKEN_COOKIE,
} from '../../../constants';

const messages = defineMessages({
  '_idagio_authorised': {
    id: 'consent-manager.cookie-purpose._idagio_authorised-2',
    defaultMessage:
      'This cookie identifies whether you have an active session, in order to redirect you to the web application.',
  },
  '_idagio_session': {
    id: 'consent-manager.cookie-purpose._idagio_session-2',
    defaultMessage: 'This cookie ensures that you remain logged in to your account.',
  },
  '_idagio_tracking_token': {
    id: 'consent-manager.cookie-purpose._idagio_tracking_token-2',
    defaultMessage: 'This cookie uniquely identifies you to our system operations services.',
  },
  'geo-redirected': {
    id: 'consent-manager.cookie-purpose.geo-redirected-2',
    defaultMessage:
      'This cookie identifies whether you have been redirected to a localised version of our app based on your location.',
  },
  'cookie-preferences': {
    id: 'consent-manager.cookie-purpose.cookie-preferences',
    defaultMessage: 'This cookie stores your cookie preferences.',
  },
  'device-id-v2': {
    id: 'consent-manager.cookie-purpose.device-id-v2-2',
    defaultMessage:
      'With this cookie we check whether you have already started playback on another device with your IDAGIO account.',
  },
  '_stripe_mid': {
    id: 'consent-manager.cookie-purpose._stripe_mid-2',
    defaultMessage:
      'With this cookie our payment processing service Stripe is able to process all payments for your orders via our website.',
  },
  '_stripe_sid': {
    id: 'consent-manager.cookie-purpose._stripe_sid-2',
    defaultMessage:
      'With this cookie our payment processing service Stripe is able to process all payments for your orders via our website.',
  },
  'cf_clearance': {
    id: 'consent-manager.cookie-purpose.cf_clearance',
    defaultMessage:
      'This cookie is issued after you successfully pass a security challenge (e.g. JavaScript or CAPTCHA). It acts as a secure token proving that you are a legitimate human visitor.',
  },
  '__cf_bm': {
    id: 'consent-manager.cookie-purpose.__cf_bm',
    defaultMessage:
      'This cookie identifies and mitigates automated web traffic, protecting the site from malicious bots and automated cyberattacks.',
  },
  'idagio-ab': {
    id: 'consent-manager.cookie-purpose.idagio-ab',
    defaultMessage:
      'This cookie stores which version of a website you were assigned in an A/B test, so that you consistently see the same variant on repeat visits.',
  },
  'country-code': {
    id: 'consent-manager.cookie-purpose.country-code',
    defaultMessage:
      'This cookie stores your country (detected from your IP address) in order to show you region-appropriate content.',
  },
  '_idagio-resetpw': {
    id: 'consent-manager.cookie-purpose._idagio-resetpw',
    defaultMessage:
      'This cookie saves the reset password token when you click the reset password link in your email.',
  },
  'cf_entry': {
    id: 'consent-manager.cookie-purpose.cf_entry',
    defaultMessage:
      'This cookie is used to track your entry point to the website, helping us understand how you found us and improve our marketing efforts.',
  },
  '__idagio__from_id': {
    id: 'consent-manager.cookie-purpose.__idagio__from_id',
    defaultMessage:
      'This cookie records the campaign or referral you arrived through, for attribution purposes.',
  },
  'flash-notification': {
    id: 'consent-manager.cookie-purpose.flash-notification',
    defaultMessage:
      'This cookie carries authentication-related notifications to you across a website redirect.',
  },
  '_idagio-voucher': {
    id: 'consent-manager.cookie-purpose._idagio-voucher',
    defaultMessage:
      'This cookie stores voucher details from the website so that your offer can be applied.',
  },
  'search-tip-closed': {
    id: 'consent-manager.cookie-purpose.search-tip-closed',
    defaultMessage:
      "This cookie remembers that you dismissed the search tip, so we don't show it to you again.",
  },
  'ctc': {
    id: 'consent-manager.cookie-purpose.ctc',
    defaultMessage: 'This cookie detects in-app web views and is used to adapt your experience.',
  },
  'basename': {
    id: 'consent-manager.cookie-purpose.basename',
    defaultMessage:
      'This cookie remembers your preferred language and locale, so that we serve you the correct localised version of the website.',
  },
  'ajs_anonymous_id': {
    id: 'consent-manager.cookie-purpose.ajs_anonymous_id',
    defaultMessage:
      'This cookie is used for analytics and helps us count how many people visit a given page, by recording whether you have visited it before. It also records your plays, which we need to report and pay royalties to rights holders and to show your recently played items. That part is required to run the service and continues regardless of your choice.',
  },
  'ajs_user_id': {
    id: 'consent-manager.cookie-purpose.ajs_user_id',
    defaultMessage:
      'This cookie helps us track your usage and events, and measures the performance and stability of the website. It also records your plays, which we need to report and pay royalties to rights holders and to show your recently played items. That part is required to run the service and continues regardless of your choice.',
  },
  '_ga': {
    id: 'consent-manager.cookie-purpose._ga-2',
    defaultMessage:
      'This cookie stores the pseudonymous ID used by Google Analytics, which helps us recognise you as a returning visitor, so that we can measure website usage and how many visitors go on to register.',
  },
  '_ga_{token}': {
    id: 'consent-manager.cookie-purpose._ga_{token}',
    defaultMessage:
      'This cookie is used by Google Analytics to store and count page views and sessions, and to track your behaviour across a specific website.',
  },
  '_gid': {
    id: 'consent-manager.cookie-purpose._gid-2',
    defaultMessage:
      'With this cookie we can count and track the number of page views you make on our sites.',
  },
  '_gat': {
    id: 'consent-manager.cookie-purpose._gat-2',
    defaultMessage:
      'This cookie is used to manage the rate at which your page view requests are made.',
  },
  'ab.storage.deviceId.{deviceId}': {
    id: 'consent-manager.cookie-purpose.ab.storage.deviceId.{deviceId}-2',
    defaultMessage:
      'This cookie is used by Braze to manage your account, personalise your experience on our website, and for marketing purposes.',
  },
  'ab.storage.sessionId.{sessionId}': {
    id: 'consent-manager.cookie-purpose.ab.storage.sessionId.{sessionId}-2',
    defaultMessage:
      'This cookie is used by Braze to manage your account, personalise your experience on our website, and for marketing purposes.',
  },
  'ab.storage.userId.{userId}': {
    id: 'consent-manager.cookie-purpose.ab.storage.userId.{userId}-2',
    defaultMessage:
      'This cookie is used by Braze to manage your account, personalise your experience on our website, and for marketing purposes.',
  },
  '_fbp': {
    id: 'consent-manager.cookie-purpose._fbp-2',
    defaultMessage:
      "This cookie is set by the Facebook pixel. Facebook uses it to record and report your actions after you have viewed or clicked one of Facebook's ads, in order to measure the effectiveness of the ad and to show you targeted advertising.",
  },
  '_uetsid': {
    id: 'consent-manager.cookie-purpose._uetsid-2',
    defaultMessage:
      'This cookie helps Bing to deliver adverts that are more relevant to you and your interests, and is also used to limit the number of times you see an advertisement.',
  },
  '_uetvid': {
    id: 'consent-manager.cookie-purpose._uetvid-2',
    defaultMessage:
      'This cookie helps Bing to deliver adverts that are more relevant to you and your interests, and is also used to limit the number of times you see an advertisement.',
  },
  '_gcl_au': {
    id: 'consent-manager.cookie-purpose._gcl_au',
    defaultMessage:
      'Set by Google Tag Manager to store and track conversions (such as purchases or sign-ups) that result from your visit, so that we can measure the effectiveness of our Google Ads campaigns and attribute them to specific ad clicks.',
  },
  '_twpid': {
    id: 'consent-manager.cookie-purpose._twpid',
    defaultMessage:
      'Set by X to recognise you across different websites, in order to optimise the relevance of advertising, measure ad performance (conversion tracking) and deliver personalised content to you.',
  },
});

export const cookies = [
  {
    name: IDAGIO_AUTHORISED_COOKIE,
    message: messages._idagio_authorised,
    owner: 'IDAGIO',
    duration: 'Session',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: '_idagio_session',
    message: messages._idagio_session,
    owner: 'IDAGIO',
    duration: '6 months',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: TRACKING_TOKEN_COOKIE,
    message: messages._idagio_tracking_token,
    owner: 'IDAGIO',
    duration: '6 months',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: 'geo-redirected',
    message: messages['geo-redirected'],
    owner: 'IDAGIO',
    duration: 'Session',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: COOKIE_PREFERENCES_COOKIE,
    message: messages['cookie-preferences'],
    owner: 'IDAGIO',
    duration: '400 days (browser max)',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: 'device-id-v2',
    message: messages['device-id-v2'],
    owner: 'IDAGIO',
    duration: '400 days (browser max)',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: '_stripe_mid',
    message: messages._stripe_mid,
    owner: 'Stripe',
    duration: '1 year',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: '_stripe_sid',
    message: messages._stripe_sid,
    owner: 'Stripe',
    duration: '1 day',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: 'cf_clearance',
    message: messages.cf_clearance,
    owner: 'Cloudflare',
    duration: '1 year',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: '__cf_bm',
    message: messages.__cf_bm,
    owner: 'Cloudflare',
    duration: '30 minutes',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: 'cf_entry',
    message: messages.cf_entry,
    owner: 'Cloudflare',
    duration: '20 seconds',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: 'idagio-ab',
    message: messages['idagio-ab'],
    owner: 'IDAGIO',
    duration: 'Session',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: 'country-code',
    message: messages['country-code'],
    owner: 'IDAGIO',
    duration: 'Session',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: '_idagio-resetpw',
    message: messages['_idagio-resetpw'],
    owner: 'IDAGIO',
    duration: 'Session',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: '__idagio__from_id',
    message: messages.__idagio__from_id,
    owner: 'IDAGIO',
    duration: 'Session',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: 'flash-notification',
    message: messages['flash-notification'],
    owner: 'IDAGIO',
    duration: 'Session',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: '_idagio-voucher',
    message: messages['_idagio-voucher'],
    owner: 'IDAGIO',
    duration: 'Session',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: 'search-tip-closed',
    message: messages['search-tip-closed'],
    owner: 'IDAGIO',
    duration: 'Session',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: 'ctc',
    message: messages.ctc,
    owner: 'IDAGIO',
    duration: 'Session',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: 'basename',
    message: messages.basename,
    owner: 'IDAGIO',
    duration: 'Session',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'necessary',
  },
  {
    name: 'ajs_anonymous_id',
    message: messages.ajs_anonymous_id,
    owner: 'Segment',
    duration: '1 year',
    type: 'HTTP Cookie + Local Storage',
    domain: '.idagio.com',
    category: 'marketingAndAnalytics',
  },
  {
    name: 'ajs_user_id',
    message: messages.ajs_user_id,
    owner: 'Segment',
    duration: '1 year',
    type: 'HTTP Cookie + Local Storage',
    domain: '.idagio.com',
    category: 'marketingAndAnalytics',
  },
  {
    name: '_ga',
    message: messages._ga,
    owner: 'Google',
    duration: '400 days (browser max)',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'marketingAndAnalytics',
  },
  {
    name: '_ga_{token}',
    message: messages['_ga_{token}'],
    owner: 'Google',
    duration: '400 days (browser max)',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'marketingAndAnalytics',
  },
  {
    name: '_gid',
    message: messages._gid,
    owner: 'Google',
    duration: '24 hours',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'marketingAndAnalytics',
  },
  {
    name: '_gat',
    message: messages._gat,
    owner: 'Google',
    duration: '1 minute',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'marketingAndAnalytics',
  },
  {
    name: 'ab.storage.deviceId.{deviceId}',
    message: messages['ab.storage.deviceId.{deviceId}'],
    owner: 'Braze',
    duration: '1 year',
    type: 'HTTP Cookie + Local Storage',
    domain: '.idagio.com',
    category: 'advertising',
  },
  {
    name: 'ab.storage.sessionId.{sessionId}',
    message: messages['ab.storage.sessionId.{sessionId}'],
    owner: 'Braze',
    duration: '1 year',
    type: 'HTTP Cookie + Local Storage',
    domain: '.idagio.com',
    category: 'advertising',
  },
  {
    name: 'ab.storage.userId.{userId}',
    message: messages['ab.storage.userId.{userId}'],
    owner: 'Braze',
    duration: '1 year',
    type: 'HTTP Cookie + Local Storage',
    domain: '.idagio.com',
    category: 'advertising',
  },
  {
    name: '_fbp',
    message: messages._fbp,
    owner: 'Facebook',
    duration: '3 months',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'advertising',
  },
  {
    name: '_uetsid',
    message: messages._uetsid,
    owner: 'Bing',
    duration: '1 day',
    type: 'HTTP Cookie + Local Storage',
    domain: '.idagio.com',
    category: 'advertising',
  },
  {
    name: '_uetvid',
    message: messages._uetvid,
    owner: 'Bing',
    duration: '390 days',
    type: 'HTTP Cookie + Local Storage',
    domain: '.idagio.com',
    category: 'advertising',
  },
  {
    name: '_gcl_au',
    message: messages._gcl_au,
    owner: 'Google',
    duration: '3 months',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'advertising',
  },
  {
    name: '_twpid',
    message: messages._twpid,
    owner: 'X',
    duration: '390 days',
    type: 'HTTP Cookie',
    domain: '.idagio.com',
    category: 'advertising',
  },
];
